import React, { useState, useEffect, useRef } from 'react';
import customHeaders, { getSpace } from '../../../../common/headers';
import useGeneralStore from '../../../../store/general';
import { ButtonBasic, usePagination, TableBox, ButtonClose } from "@lk-gtcom/ecomlab-components";
import { ModalAddFields } from '../Modal/ModalAddFields/ModalAddFields';
import { useShallow } from 'zustand/react/shallow';
import { useDataTable } from '../../../../common/hooks';
import { useResponseHandler } from '../../../../common/auth';
import './ContactCRM.scss';

interface ContactCRMProps {
    modal?: boolean,
    setIsModal?: (isModal: boolean) => void
    addContact?: (contact_id: number | string) => void
}

type PaginatorParams = {
    page?: number;
    limit?: number;
    // Добавьте нужные поля
};

type PaginatorRefType = {
    page?: number;
    limit?: number;
    params: PaginatorParams;
    setTotal?: (total: number) => void;
};

interface TableProps {
    filters: any;
    sort: any;
    total: number;
    loading: boolean;
}

interface SetTableFuncs {
    setLoading: (loading: boolean) => void;
}

const ContactCRM = ({
    modal = false,
    setIsModal = () => { },
    addContact = () => { }
}: ContactCRMProps) => {
    const selectedSpace = useGeneralStore((state) => state.selectedSpace);
    const headers = { ...customHeaders, ...getSpace(selectedSpace) };
    const { handleStatusCode, handleTableResponse, handleRequestError } = useResponseHandler();
    const {
        isModalContact,
        setIsModalContact,
        currentContact,
        setCurrentContact
    } = useGeneralStore(
        useShallow((state) => ({
            currentContact: state.currentContact,
            isModalContact: state.isModalContact,
            setCurrentContact: state.setCurrentContact,
            setIsModalContact: state.setIsModalContact
        }))
    );

    const [contactList, setContactList] = useState([])
    const [isModalFields, setIsModalFields] = useState(false)
    const [load, setLoad] = useState(true)


    // Таблица
    const [isTableRequest, setIsTableRequest] = useState(false);
    const paginatorRef = useRef<PaginatorRefType>()
    const [setTable, tableProps, setTableFuncs] = useDataTable(
        paginatorRef.current?.setTotal,
        paginatorRef
    ) as any
    const { setLoading } = setTableFuncs as SetTableFuncs;
    const { loading, sort, filters } = tableProps as TableProps;


    const btns = [
        {
            btn: 'Удалить',
            func: (e: number) => fetchDeleteContact(e)
        },
    ];

    // Пагинация
    const paginatorCallback = useRef();
    const [
        page,
        limit,
        total,
        setTotal,
        Paginator,
        resetPaginator,
        paginatorTransition,
    ] = usePagination(
        paginatorCallback.current,
        [],
        paginatorRef?.current?.params
    );

    // Получение списка контактов
    const fetchTableData = (params: any, abortController = new AbortController()) => {
        let _sort;
        let filtersParam = [];

        if (params) {
            [_sort, filtersParam] = params;
        }

        // Устанавливаем loading в true только если запрос не прерван
        if (!abortController.signal.aborted) {
            setLoading(true);
        }

        let url = ` https://portals.ecomru.ru/api/crm/contacts/table_view`;

        const body = JSON.stringify({
            page: paginatorRef.current?.page,
            limit: paginatorRef.current?.limit,
            filters: Array.isArray(filtersParam) ? filtersParam : filters,
            search: '',
            order_field: _sort?.[0] || sort?.[0],
            order_direction: _sort?.[1] || sort?.[1]
        });

        fetch(url, { body, method: 'POST', headers, signal: abortController.signal })
            .then(handleTableResponse)
            .then((json) =>  setTable(json))
            .catch(handleRequestError)
            .finally(() => {
                if (!abortController.signal.aborted) {
                    setLoading(false);
                }
            });
    };

    // Удаление контакта
    const fetchDeleteContact = (id: number) => {
        let url = ` https://portals.ecomru.ru/api/crm/contacts/${id}`

        fetch(url, { method: 'DELETE', headers })
            .then(handleTableResponse)
            .then((json) => setIsTableRequest(!isTableRequest))
            .catch(handleRequestError);
    };

    useEffect(() => {
        if (!isModalContact) {
            const abortController = new AbortController();
            fetchTableData([], abortController)
            return () => abortController.abort();
        }
    }, [isTableRequest, isModalContact]);

    const contextMenuArr = [
        {
            label: 'Удалить',
            onClick: (e: { 'id контакта': number}) => fetchDeleteContact(e?.["id контакта"]),
        },
    ];

    const onAction = (e: { 'id контакта': number | string }) => {
        setCurrentContact(e?.["id контакта"])
        setIsModalContact(true)
    }


    return (
        <>
            <div className={modal ? 'blackout' : ''}
                onClick={(e) => {
                    let el = e.target as HTMLElement
                    if (el.classList.contains('blackout')) {
                        setIsModal(false)
                    }
                }}>

                {isModalFields && <ModalAddFields
                    setIsModal={setIsModalFields}
                    stringUrl='contacts'
                />}

                <div className={`contact-CRM`}>

                    <div className={`contact-CRM__content`}>

                        <div className={`contact-CRM__btn-group`}>
                            <ButtonBasic
                                violet
                                text='+ Добавить контакт'
                                onClick={() => setIsModalContact(true)}
                            />

                            <ButtonBasic
                                whiteBlue
                                text='+ Создать поля'
                                onClick={() => setIsModalFields(true)}
                            />

                            {modal && <ButtonClose
                                onClick={() => setIsModal(false)}
                            />}

                        </div>

                        <TableBox
                            {...tableProps}
                            paginator={true}
                            ref={paginatorRef}
                            fetchCallback={fetchTableData}
                            contextMenuArr={contextMenuArr}
                            onAction={onAction}
                        />
                    </div>
                </div >
            </div>
        </>
    );
};

export { ContactCRM };